import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Tabs } from 'antd';
import VerificationCode from '../../../Login/VerificationCode';
import Password from '../../../Login/Password';
import ForgetPassword from '../../../Login/ForgetPassword';
import s from '../../../Login/style.m.less';
import withRouter from '@/components/withRouter';
import GrtLoading from '@/components/GrtLoading/GRTLoading';
import style from './style.m.less';
import backIcon from '@/assets/images/mentalHealth/2026/back.webp';
import topLogo from '@/assets/images/yfbCompetition/top_logo.webp';

/**
 *  北京教育学院杨帆杯大赛
 */
@inject('store')
@observer
class YfbCompetition extends Component {
    state = {
        loading: true
    };
    async componentDidMount() {
        const {
            store: { login }
        } = this.props,
         competition_id = this.props.params?.id || '',
         isLogin = await login.checkLogin();
        // 登录成功后跳转到杨帆被大赛专题页 /2026/competition_yfb_tenant/:id
        login.setRedirectUrl(`https://${window.location.host}/web/2026/competition_yfb_tenant/${competition_id}`);
        if (isLogin) {
            return login.loginCallback(null,'competition');
        }
        this.setState({
            loading: false
        });
    }
    onChange = (activeKey) => {
        const {
            store: { login }
        } = this.props;

        login.setActiveKey(activeKey);
    };

    render() {
        const {
            store: { login }
        } = this.props;

        return this.state.loading ?
        <GrtLoading /> :
        <div className={`${s.competition_app}`}>
            <div className={style.yfb_competition_bg}>
                <div className={style.yfb_contet_wrap}>
                    <div className={style.city_competition_logo}>
                        <img src={topLogo} alt="北京教育学院人文与外语教育学院" className={style.top_logo} />
                        <div className={style.city_login_wrap}>
                            <div className={style.login_icon}></div>
                            <div className={style.mental_health_competition_content}>
                                <Card hoverable>
                                    {login.mode === 'login' ? (
                                        <Tabs
                                            onChange={this.onChange}
                                            activeKey={login.activeKey}
                                            items={[
                                                {
                                                    key: 'code',
                                                    label: '验证码登录',
                                                    children: <VerificationCode type="competition" />
                                                },
                                                {
                                                    key: 'password',
                                                    label: '密码登录',
                                                    children: <Password type="competition" />
                                                }
                                            ]}
                                        />
                                    ) : (
                                        <ForgetPassword type="competition" backIcon={`url(${backIcon})`} />
                                    )}
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={style.footer}>
                    <div className={style['footer_content_wrap']}>
                        <div className={style.footer_logo}></div>
                        <div className={style.footer_text}>
                            <div className={style.footer_item}>主办单位：北京教育学院人文与外语教育学院历史系</div>
                            <div className={style.footer_item}>技术支持：北京国人通教育科技有限公司</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

export default withRouter(YfbCompetition);
